import type { ReactNode } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { getGoogleClientId } from '../lib/google-client-id';

/**
 * Wrapper do `GoogleOAuthProvider` que lê o Client ID do build env.
 *
 * Se `VITE_GOOGLE_CLIENT_ID` não estiver setado, renderiza children sem o
 * provider — `@react-oauth/google` joga erro feio em runtime se tentar usar
 * `useGoogleLogin` sem provider. A `LoginPage` checa essa env via
 * `getGoogleClientId()` antes de chamar o hook e mostra mensagem clara
 * quando ausente (fallback pro dev-login em DEV).
 */
export function GoogleLoginProvider({ children }: { children: ReactNode }) {
  const clientId = getGoogleClientId();
  if (!clientId) {
    return <>{children}</>;
  }
  return <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>;
}
